export default "__VITE_ASSET__B3F$wXAC__"